import { render, staticRenderFns } from "./Subindicadores.vue?vue&type=template&id=226329f5&"
import script from "./Subindicadores.vue?vue&type=script&lang=js&"
export * from "./Subindicadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports